import React, {useState} from "react";
import play from "./assets/play-2.svg";
const GetYouProjects = () => {
  return (
    <div className="flex flex-col md:flex-row gap-x-[19px] gap-y-[30px]">
      <div className="bg-custom-gradient flex-grow-1 w-full md:w-[450px] xl:w-[740px] col-span-2 row-span-2 min-h-[520px] rounded-[10px] py-[40px] px-[39px] flex items-end relative">
        <div>
          <h2 className="text-res-lg text-main-black font-extrabold mb-[10px]">
            Get your projects Funded
          </h2>
          <p className="text-res-ls text-main-black font-medium">
            Discover how you can actively participate in the R34P DAO community
            and contribute to the advancement of decentralized finance. Gain
            exclusive access to governance, presales, and exciting investment
            opportunities. Join us in shaping the future of finance and
            unlocking the potential of the decentralized ecosystem.
          </p>
        </div>

        {/* icon */}
        <div className="absolute w-[36px] h-[36px] flex justify-center items-center bg-[#8F949B] shadow-[0px_4px_4px_rgba(6,89,64,0.5)] rounded-full right-[21px] top-[21px]">
          <button>
            <img src={play} className="w-[21px] h-[21px] ml-1" alt="" />
          </button>
        </div>
      </div>
      <div className="grow">
        <div className="h-full flex flex-col gap-[30px] w-full">
          <div className="h-1/2 bg-main-black w-full rounded-[20px] relative  flex items-end px-[39px] py-[32px] min-h-[245px]">
            <div>
              <h2 className="text-res-base font-extrabold">Apply for Raise</h2>
            </div>

            {/* icon */}
            <div className="absolute w-[36px] h-[36px] flex justify-center items-center bg-[#8F949B] shadow-[0px_4px_4px_rgba(6,89,64,0.5)] rounded-full right-[19px] top-[15px]">
              <button>
                <img src={play} className="w-[21px] h-[21px] ml-1" alt="" />
              </button>
            </div>
          </div>
          <div className="h-1/2 bg-main-black w-full rounded-[20px] relative  flex items-end px-[28px] py-[32px] min-h-[245px]">
            <div>
              <h2 className="text-res-base font-extrabold">What is a DAO?</h2>
            </div>
            {/* icon */}
            <div className="absolute w-[36px] h-[36px] flex justify-center items-center bg-[#8F949B] shadow-[0px_4px_4px_rgba(6,89,64,0.5)] rounded-full right-[19px] top-[15px]">
              <button>
                <img src={play} className="w-[21px] h-[21px] ml-1" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetYouProjects;
